import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../../@types/RootState';
import { ButtonPrimary, Callout, Layout, SearchInput } from '../../../../../../../components';
import { useDebounce } from '../../../../../../../hooks';
import { SET_RULES_FILTERS_NAME } from '../../../../../../../reducers/ipa/strategy/rulesPage/filters/name';
import { useDataUltimaIntegracao } from '../../../../../RevisaoPrecos/hooks';
import styles from './RulesPageHeader.module.scss';

type RulesPageHeaderProps = RouteComponentProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const RulesPageHeader = ({ history, name, setRuleName }: RulesPageHeaderProps) => {
  const debounce = useDebounce();

  const { parsedDate: lastUpdatedDate } = useDataUltimaIntegracao();

  const handleClickNewRule = useCallback(() => {
    history.push('/ipa/regras-preco/cadastro');
  }, [history]);

  const handleChangeName = useCallback(
    ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      debounce(() => setRuleName(target.value));
    },
    [debounce, setRuleName],
  );

  return (
    <Layout.Section padded className={styles.header}>
      <div>
        <span className={styles['title-wrapper']}>
          <Layout.Title>Regras de preço</Layout.Title>
          <Callout size="xxs" variant="warning">
            As alterações serão aplicadas na próxima integração de dados
          </Callout>
        </span>
        <Layout.Subtitle>Última atualização: {lastUpdatedDate}</Layout.Subtitle>
      </div>
      <div className={styles['input-wrapper']}>
        <SearchInput
          className={styles.input}
          id="rule-name-input"
          name="rule-name-input"
          type="text"
          placeholder="Pesquise por uma regra"
          defaultValue={name}
          onChange={handleChangeName}
        />
        <ButtonPrimary onClick={handleClickNewRule}>nova regra</ButtonPrimary>
      </div>
    </Layout.Section>
  );
};

const mapStateToProps = (state: RootState) => ({
  name: state.ipa.strategy.rules.filters.name,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setRuleName: (value = '') => dispatch(SET_RULES_FILTERS_NAME(value)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RulesPageHeader));
